// src/routes/legacyPaths.js
// Host pages used to live under /clubastra/... (and the unused /manage/...
// copies), which looked wrong on other brands' portals. They now sit at the
// root (/tickets, /pays, ...). Old links (bookmarks, saved guide overrides,
// popups) still work: the router sends them through toNeutralPath.
// Plain JS with no imports so scripts/guides.test.mjs can load it under node.

const LEGACY_PREFIX = /^\/(clubastra|manage)(?=\/[^/])/;

// '/clubastra/tickets?x=1' -> '/tickets?x=1'. Anything else comes back as is.
export function toNeutralPath(path) {
  if (typeof path !== 'string') return path;
  return path.replace(LEGACY_PREFIX, '');
}
